import { withTheme } from '@mui/styles';
import styled from 'styled-components';

const SimpleStepSectionStyle = withTheme(styled.div`
  background-color: #f7f7f7;
  padding: 60px 0px;

  .content-container {
    padding-top: 30px;

    .menu {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding-bottom: 40px;

      .menu-item {
        font-size: 24px;
        margin: 5px;
        width: 180px;
        line-height: 1.21;
        color: #707070;
        cursor: pointer;
        border-bottom: 2px solid #f7f7f7;

        span {
          padding-bottom: 2px;
        }

        &.active {
          color: ${(props: any) => props.theme.palette.primary.dark};
          border-bottom: 2px solid ${(props: any) => props.theme.palette.primary.dark};
        }
      }
    }
    .video-js {
      background: transparent;

      .vjs-big-play-button {
        line-height: 1.7;
        background-color: #174843;
        border-radius: 50%;
        border: unset;
        width: 50px;
        height: 50px;
        margin-left: -0.5em;
      }
    }
  }

  ${(props: any) => props.theme.breakpoints.down('lg')} {
    .content-container {
      padding-top: 40px;

      .menu {
        align-items: unset;
      }
    }
  }

  ${(props: any) => props.theme.breakpoints.down('sm')} {
    .content-container {
      padding-top: 12px;

      .menu {
        align-items: unset;
        .menu-item {
          font-size: 18px;
          width: 98%;
        }
      }
    }
  }
`);

export default SimpleStepSectionStyle;
